<template>
  <div id="verifyOTP" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="verifyOTP"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content stella-modal stella-auth-modal">
        <div class="modal-body  p-4 m-4">
          <img class="img-fluid float-end d-block zoom-12"
               data-dismiss="modal" src="@/assets/images/stella/close.png" @click="closeModal()">



          <div class="justify-content-center d-flex">
            <img src="@/assets/images/help-mail.svg"
            style="filter:grayscale(1) brightness(2)">
          </div>
          <h4 class="font-size-24 font-weight-bold text-center mt-4 text-white">Verify Your Identity</h4>
<!--          <p class="pt-1 pb-2 font-size-12 text-center">We have sent email with your code to <span class="success">example@gmail.com</span>
            .</p>-->
          <div class="form-group mt-3">
            <span class="danger ml-2" v-if="isRequired('otp')">This is required field</span>
            <input id="otp"
                   type="number"
                   autocomplete="false"
                   placeholder="Enter verification code"
                   class="form-control stella-input" name="otp"
                   v-model="changePassword.otp"
                   oninput="this.value = this.value.replace(/[^0-9]/g, '')">
          </div>
          <div class="d-block text-center py-1">
            <button type="button"
                    class="btn stella-btn gradient-a w-100 rounded-pill"
                    @click="verifyOTP()">Continue
            </button>
            <p class="mt-3 text-white">Didn't receive an email? <a class="success" href="#" @click.prevent="resendOTP()">Resend</a></p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {SERVICE_IDENTIY} from "@/properties/micro-service";
import {forgotPasswordMixin} from "@/mixin/forgot-password-mixin";
import ModelGlobalMessage from "@/components/module/shared/ModelGlobalMessage";
import {required} from "vuelidate/lib/validators";

export default {
  name: "ForgotPasswordVerifyOTP",
  mixins: [forgotPasswordMixin],
  components: {ModelGlobalMessage},
  data() {
    return {}
  },
  validations: {
    changePassword: {
      otp: {required},
    }
  },
  methods: {
    show(changePassword) {
      this.changePassword = changePassword;
      $('#verifyOTP').modal();
      this.setMessage("We have sent the OTP to your email");
    },
    hide() {
      $('#verifyOTP').modal('hide');
    },
    verifyOTP() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let url = `${SERVICE_IDENTIY}/api/v1/password/otp/verify`;
      this.postUnsecuredData(url, this.changePassword, (data) => {
        this.hide();
        this.$emit("otpVerified", this.changePassword);
      });
    },
    resendOTP() {

      let url = `${SERVICE_IDENTIY}/api/v1/password/otp/send`;
      this.postUnsecuredData(url, this.changePassword, (data) => {
        this.setMessage("OTP has been resent to your email");
      });
    },

    closeModal(){
      this.hide();
      this.$emit("sendOTP",this.changePassword);
    }

  }
}
</script>

<style scoped>
.stella-modal {
  background: rgba(20, 20, 20, 0.85) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 20px !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
}

.input-transparent {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 15px !important;
  font-size: 15px;
  transition: all 0.3s ease;
}

.input-transparent:focus {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(197, 111, 209, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
  outline: none;
}

.input-transparent::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* Chrome autofill override */
.input-transparent:-webkit-autofill,
.input-transparent:-webkit-autofill:hover, 
.input-transparent:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset !important;
    box-shadow: 0 0 0 1000px #1e1e1e inset !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

.input-transparent:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset, 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
    box-shadow: 0 0 0 1000px #1e1e1e inset, 0 0 0 0.2rem rgba(197, 111, 209, 0.25) !important;
    border-color: rgba(197, 111, 209, 0.5) !important;
    -webkit-text-fill-color: #ffffff !important;
    color: #ffffff !important;
    caret-color: #ffffff !important;
    outline: none !important;
    transition: background-color 50000s ease-in-out 0s !important;
}

/* Close icon hover effect */
.zoom-12 {
  transition: transform 0.2s ease;
  cursor: pointer;
  opacity: 0.7;
}
.zoom-12:hover {
  transform: scale(1.2);
  opacity: 1;
}
</style>
